
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import $ from 'jquery';

import Inputmask from "inputmask";

import Vue from 'vue';
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.component('tournament-finder-form', require('./components/TournamentFinderForm.vue').default);

var tournamentFinderEl = document.getElementById('tournament-finder');
if (tournamentFinderEl) {
    const tournamentFinder = new Vue({
        el: '#tournament-finder'
    });
}


window.openModal = function(title, message, type, cb) {
    const $modal = $('.dialog');
    const $backdrop = $('.dialog-backdrop');
    // If modal not found then die early.
    if(!$modal.length || !$backdrop.length) {
        // Fallback
        alert(message);
        return;
    }

    $modal.find('.dialog-title').text(title);
    $modal.find('.dialog-text').text(message);

    // The type currently is either confirm or alert
    $modal.removeClass('modal-out').addClass(`modal-in ${type}`);
    $backdrop.removeClass('backdrop-out').addClass('backdrop-in');

    const $buttons = $modal.find('.dialog-buttons .dialog-button');

    const handleClick = function(event) {
        event.preventDefault();
        if(cb) {
            if($(this).hasClass('dialog-button__ok')) {
                cb(true);
            } else { // Cancel button
                cb(false);
            }
        }

        $modal.removeClass('modal-in').addClass('modal-out')
            .one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
                $modal.removeClass(type);
                $backdrop.removeClass('backdrop-in').addClass('backdrop-out');
            });
        $buttons.unbind('click');
    };

    $buttons.one('click', handleClick);
};

$(function(){
    Inputmask({"mask": "(999) 999-9999"}).mask('.phone');
});
